import {
  FileViewerTranslations,
} from '../types/file-viewer.types';
import { resolveLanguageCode } from '../utils/file-viewer.utils';

const FILE_VIEWER_TRANSLATIONS: Record<string, FileViewerTranslations> = {
  en: {
    back: 'Back',
    cancel: 'Cancel',
    confirm: 'Confirm',
    deleteFileMessage: 'Are you sure you want to delete this file?',
    deleteFileTitle: 'Delete file',
    download: 'Download',
    downloadFileMessage: 'Are you sure you want to download this file?',
    downloadFileTitle: 'Download',
    fileFallbackName: 'file',
    fit: 'Fit',
    fitWidth: 'Fit width',
    imageFallbackTitle: 'Image',
    noImageAvailable: 'No image available.',
    noPdfAvailable: 'No PDF available.',
    noVideoAvailable: 'No video available.',
    pdfFallbackTitle: 'PDF',
    videoFallbackTitle: 'Video',
  },
  it: {
    back: 'Indietro',
    cancel: 'Annulla',
    confirm: 'Conferma',
    deleteFileMessage: 'Sei sicuro di voler eliminare questo file?',
    deleteFileTitle: 'Elimina file',
    download: 'Scarica',
    downloadFileMessage: 'Sei sicuro di voler scaricare questo file?',
    downloadFileTitle: 'Download',
    fileFallbackName: 'file',
    fit: 'Adatta',
    fitWidth: 'Adatta larghezza',
    imageFallbackTitle: 'Immagine',
    noImageAvailable: 'Nessuna immagine da visualizzare.',
    noPdfAvailable: 'Nessun PDF da visualizzare.',
    noVideoAvailable: 'Nessun video da visualizzare.',
    pdfFallbackTitle: 'PDF',
    videoFallbackTitle: 'Video',
  },
};

export function getFileViewerTranslations(languageCode: string | null | undefined): FileViewerTranslations {
  const normalizedCode = resolveLanguageCode(languageCode);
  return FILE_VIEWER_TRANSLATIONS[normalizedCode] ?? FILE_VIEWER_TRANSLATIONS['it'];
}
